






import { Component, Prop, Vue } from "vue-property-decorator";

import { EditSheetCharacteristics, EditSheetCharacteristicsUnit } from "./edit/types/edit-measurements-characteristic";

@Component
export default class CharacteristicTitle extends Vue {
  @Prop() characteristic!: EditSheetCharacteristics;

  private formatUnit(unit: string) {
    return unit.replace("Degrees", "°").replace("Degree", "°");
  }

  get name(): string {
    return this.characteristic.translations[this.$i18n.locale];
  }

  get unit(): string {
    return this.characteristic.unitTranslations[this.$i18n.locale];
  }
}
